// extracted by mini-css-extract-plugin
export var button = "_b6-4";
export var hasDarkBackground = "_b6-7";
export var hasLightBackground = "_b6-6";
export var iconWrapper = "_b6-0";
export var large = "_b6-2";
export var medium = "_b6-1";
export var small = "_b6-5";
export var xsmall = "_b6-3";